module.exports = __webpack_public_path__ + "static/media/world_04.de860fd1.png";